import React, { useState, useEffect } from 'react';
import './ImagePopup.css';

/**
 * Cinematic announcement popup. Shows /popup.jpg on every page load.
 * - Drop your image at  public/popup.jpg
 * - Auto-hides gracefully if the image is missing (onError).
 */
const ImagePopup = ({ src = '/popup.jpg' }) => {
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 600); // small cinematic delay
    return () => clearTimeout(t);
  }, []);

  const close = () => setOpen(false);

  if (!open || failed) return null;

  return (
    <div className="popup-overlay" onClick={close}>
      <div className="popup-card" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={close} aria-label="Close">×</button>
        <img
          src={src}
          alt="Announcement"
          className="popup-img"
          onError={() => setFailed(true)}
        />
      </div>
    </div>
  );
};

export default ImagePopup;
